import React from 'react';
import images from './images';

const SHOW_TAKE_SURVEY_BUTTON_TIMEOUT = 300;

class MobileDemo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showIntegrationTypeButtons: true,
      showTakeSurveyButtons: false,
      showRewardDetails: false,
      showNoReward: false,
      integration: 'rewarded',
    };

    this.handlePostMessages = this.handlePostMessages.bind(this);
    this.showFullSurvey = this.showFullSurvey.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.timer = null;
  }

  componentDidMount() {
    document.title = 'Mobile Demo | Check a Pollfish Survey Here';
    document.querySelector("meta[property='og:title']").setAttribute('content', 'Mobile Demo | Check a Pollfish Survey Here');
    window.addEventListener('message', this.handlePostMessages);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
    window.removeEventListener('message', this.handlePostMessages, true);
  }

  render() {
    const showRewardDetails = this.state.showRewardDetails;
    const showIntegrationTypeButtons = this.state.showIntegrationTypeButtons;
    const showTakeSurveyButtons = this.state.showTakeSurveyButtons;
    const showNoReward = this.state.showNoReward;
    const integration = this.state.integration;
    
    const showPhoneButtons = 
      (showTakeSurveyButtons && !showRewardDetails && !showNoReward) ||
      (integration === 'offerwall' && showTakeSurveyButtons);

    const iframeContent = `
    <!DOCTYPE html>
      <html>
        <body>
          <script type="text/javascript">
            var pollfishConfig = {
              api_key: "7454acc3-0e44-451f-adf3-23693679b41c",
              debug: true,
              user_id: "12345",
              request_uuid: "123123",
              offerwall: ${integration === 'offerwall' ? true : false}
            };
            pollfishConfig.ready = () => window.parent.postMessage('webPluginReady', '*');
            pollfishConfig.closeCallback = () => window.parent.postMessage('webPluginClose', '*');
            pollfishConfig.userNotEligibleCallback = () => window.parent.postMessage('webPluginUserNotEligible', '*');
            pollfishConfig.closeAndNoShowCallback = () => window.parent.postMessage('webPluginCloseAndNoShow', '*');
            pollfishConfig.surveyCompletedCallback = (data) => window.parent.postMessage(JSON.stringify({type: 'webPluginSetSurveyCompleted', ...data}), '*');
            pollfishConfig.userRejectedSurvey = () => window.parent.postMessage('webPluginUserRejectedSurvey', '*');
          </script>
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.2/jquery.min.js"></script>
          <script src="https://storage.googleapis.com/pollfish_production/sdk/webplugin/pollfish.min.js"></script>
        </body>
    </html>
  `;
    
    return (
      <div>
        <div
          className="mobile-demo"
          style={{
            backgroundImage: `url(${images.background})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
          }}
        >
          <div className="mobile-demo-actions">
            { showIntegrationTypeButtons && !showRewardDetails && !showNoReward && (
              <button
                className={`mobile-demo-btn${integration === 'rewarded' ? ' mobile-demo-btn--active' : ''} mobile-demo-btn--left`}
                onClick={() => this.setState({integration: 'rewarded'})}
              >
                Rewarded Survey
              </button>
            )}
            { showIntegrationTypeButtons && !showRewardDetails && !showNoReward && (
              <button
                className={`mobile-demo-btn${integration === 'offerwall' ? ' mobile-demo-btn--active' : ''} mobile-demo-btn--right`}
                onClick={() => this.setState({integration: 'offerwall'})}
              >
                Offerwall
              </button>
            )}
          </div>
          <span
            className="mobile-demo-refresh"
            onClick={this.handleRefresh}
          >
            <img className="mobile-demo-refresh-icon" src={images.refreshIcon} alt="refresh-icon" />
            Refresh
          </span>
          <div
            className="mobile-demo-phone"
          >
            <img src={images.phoneBackground} className="mobile-demo-phone-bg" alt="phone-background" />
            { showRewardDetails && integration === "rewarded" && <img src={images.phoneRewardBackground} className="mobile-demo-phone-bg" alt="phone-reward-background" />}
            <img src={images.phone} className="mobile-demo-phone-bg" alt="phone" />
            { showRewardDetails && integration === 'rewarded' && (
              <div className="mobile-demo-phone-reward">
                <span className="mobile-demo-phone-reward-text">You just won!</span>
                <img src={images.rewardIcon} className="mobile-demo-phone-reward-icon" alt="reward-icon" />
              </div>
            )}
            { showNoReward && integration === 'rewarded' && (
              <div className="mobile-demo-phone-reward">
                <span className="mobile-demo-phone-reward-text">
                  { showNoReward === 'closeAndNoShow' && 'Please try again later'}
                  { showNoReward === 'userNotEligible' && 'Unfortunately you got screened out, please try again later'}
                </span>
              </div>
            )}
            <iframe
              id="web-plugin-iframe"
              className="mobile-demo-phone-iframe"
              title="Pollfish"
              srcDoc={iframeContent}
            />
            { showPhoneButtons && (
              <div className="mobile-demo-phone-actions">
                <button
                  className="mobile-demo-phone-take-survey"
                  onClick={this.showFullSurvey}
                >
                  {integration === 'offerwall' ? 'View Offers' : 'Take a Survey' }
                </button>
                <button className="mobile-demo-phone-watch-video">
                  {integration === 'offerwall' ? 'Watch Videos' : 'Watch a Video' }
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  handlePostMessages(message) {
    if (message.data === 'webPluginReady') {
      this.setState({showTakeSurveyButtons: true});
    }
    if (message.data === 'webPluginClose') {
      this.timer = setTimeout(() => {
        this.setState({showTakeSurveyButtons: true});
      }, SHOW_TAKE_SURVEY_BUTTON_TIMEOUT);
    }
    if (message.data === 'webPluginCloseAndNoShow') {
      this.setState({showNoReward: 'closeAndNoShow'});
    }
    if (message.data === 'webPluginUserNotEligible') {
      this.setState({showNoReward: 'userNotEligible'});
    }
    if (message && message.data && message.data.indexOf && message.data.indexOf('webPluginSetSurveyCompleted') !== -1) {
      this.setState({showRewardDetails: true});
    }
  }

  showFullSurvey() {
    this.setState({
      showIntegrationTypeButtons: false,
      showTakeSurveyButtons: false,
    });
    document
      .getElementById('web-plugin-iframe')
      .contentWindow.Pollfish.showFullSurvey();
      

    const pollfishSurveyContainerStyle = document
      .getElementById('web-plugin-iframe')
      .contentWindow
      .document
      .getElementById('pollfishSurveyContainer')
      .style;
    
    pollfishSurveyContainerStyle.width = '100%';
    pollfishSurveyContainerStyle.bottom = '0';
    pollfishSurveyContainerStyle.height = '100%';
    pollfishSurveyContainerStyle.maxHeight = '100%';
  }

  handleRefresh() {
    this.setState({
      showIntegrationTypeButtons: true,
      showTakeSurveyButtons: false,
      showRewardDetails: false,
      showNoReward: false,
      integration: 'rewarded',
    });
    document
      .getElementById('web-plugin-iframe')
      .contentWindow.Pollfish.restart(
        document
          .getElementById('web-plugin-iframe')
          .contentWindow.pollfishConfig
      );
  }
}

export default MobileDemo;



// WEBPACK FOOTER //
// ./src/components/MobileDemo/index.js